import { operators as o } from '@pendo/aggregations';

export function NamedAggregation (aggregation, fact, kindId, id) {
    if (id.startsWith('guideElement') || id.startsWith('emailElement') || id.startsWith('feedbackRequest')) {
        return aggregation.push(o.group([kindId], o.groupField(id, o.count(null))));
    }
    switch (fact) {
        case 'eventCount':
            return aggregation.push(o.group([kindId], o.groupField(id, o.sum('numEvents'))));
        case 'eventTime':
            return aggregation.push(o.group([kindId], o.groupField(id, o.sum('numMinutes'))));
        case 'daysActive':
            return aggregation.push(o.group([kindId], o.groupField(id, o.count('day'))));
        case 'deadClicks':
            return aggregation.push(o.group([kindId], o.groupField(id, o.sum('deadClickCount'))));
        case 'errorClicks':
            return aggregation.push(o.group([kindId], o.groupField(id, o.sum('errorClickCount'))));
        case 'rageClicks':
            return aggregation.push(o.group([kindId], o.groupField(id, o.sum('rageClickCount'))));
        case 'uTurns':
            return aggregation.push(o.group([kindId], o.groupField(id, o.sum('uTurnCount'))));
        case 'guideViews':
            return aggregation.push(
                ...o.pipeline(
                    o.filter('eventSubType(type)=="guideSeen"'),
                    o.group([kindId], o.groupField(id, o.count(null))),
                ),
            );
        case 'numVisitors':
            return aggregation.push(o.group([kindId], o.groupField(id, o.count('visitorId'))));
        case 'numSubAccounts':
            return aggregation.push(o.group(['parentAccountId'], o.groupField(id, o.count('accountId'))));
        case 'responseCount':
            return aggregation.push(o.group([kindId], o.groupField(id, o.count(null))));
    }

    return aggregation;
}
